module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color.a8f1badc.jpg";